import { render, staticRenderFns } from "./ListVenta.vue?vue&type=template&id=f95d1178&"
import script from "./ListVenta.vue?vue&type=script&lang=js&"
export * from "./ListVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports